<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;My DPDP Declaration</h5>
  </div>
<div id="mainContent" class="container">
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Financial Year<span class="text-danger">*</span></label
          >
          <div class="col-sm-8">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedFinancialYear"
            >
              <option value="">Select Year</option>
              <option *ngFor="let finance of financialList" [ngValue]="finance">
                {{ finance.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-sm-5">
        <div class="row">
          <div class="col-sm-6"></div>
          <div class="col-sm-4">
            <button
              type="button"
              class="btn btn-sm btn-block btn-outline-theme"
              (click)="onViewReport()"
            >
              View Report
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container" id="mainContent">
  <app-dpdp-declaration
    [isMyReport]="true"
    [dpdpDeclaration]="dpdpDeclaration" 
  ></app-dpdp-declaration>
</div>
</div>